<!-- src/App.vue -->
<template>
  <LandCover />
</template>

<script>
import LandCover from './components/LandCover.vue';

export default {
  name: 'App',
  components: {
    LandCover
  }
}
</script>

<style>
/* Global styles can go here */

body{
    margin: 0px;
}
</style>
